import { Logo } from "@/components/Logo";
import { scrollToId } from "@/lib/api";
import { Link } from "react-router-dom";

export default function Footer({ contact }) {
  return (
    <footer className="border-t border-white/10 bg-[#04060D]" data-testid="footer">
      <div className="mx-auto grid max-w-7xl gap-12 px-6 py-16 md:grid-cols-3">
        <div>
          <Logo />
          <p className="mt-5 max-w-xs text-sm leading-relaxed text-slate-400">
            Ideas Engineered Digitally. Websites, applications and AI solutions for businesses ready
            to grow.
          </p>
        </div>
        <div>
          <h3 className="font-display text-xs font-bold uppercase tracking-[0.3em] text-slate-500">Explore</h3>
          <ul className="mt-5 space-y-3 text-sm">
            {[
              ["About", "about"], ["Services", "services"], ["Packages", "packages"],
              ["Our Work", "work"], ["Maintenance", "maintenance"], ["FAQ", "faq"], ["Contact", "contact"],
            ].map(([label, id]) => (
              <li key={id}>
                <a
                  href={`#${id}`}
                  data-testid={`footer-${id}-link`}
                  onClick={(e) => { e.preventDefault(); scrollToId(id); }}
                  className="text-slate-400 transition-colors duration-200 hover:text-[#00F0FF]"
                >
                  {label}
                </a>
              </li>
            ))}
          </ul>
        </div>
        <div>
          <h3 className="font-display text-xs font-bold uppercase tracking-[0.3em] text-slate-500">Get in touch</h3>
          <ul className="mt-5 space-y-3 text-sm text-slate-400">
            <li>
              <a href={`mailto:${contact.email}`} data-testid="footer-email-link" className="transition-colors duration-200 hover:text-[#00F0FF]">
                {contact.email}
              </a>
            </li>
            <li>
              <a
                href={`https://wa.me/${contact.whatsapp_number}`}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-whatsapp-link"
                className="transition-colors duration-200 hover:text-[#00F0FF]"
              >
                WhatsApp: {contact.whatsapp_display}
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="mx-auto flex max-w-7xl flex-wrap items-center justify-between gap-4 px-6 py-6 text-xs text-slate-500">
          <p>© 2026 Tarbyte Digital Products &amp; Technology. All rights reserved.</p>
          <Link to="/admin/login" data-testid="footer-admin-link" className="transition-colors duration-200 hover:text-[#00F0FF]">
            Owner login
          </Link>
        </div>
      </div>
    </footer>
  );
}
